import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import { FAQS, SITE } from '../data/site';

export default function FaqPage() {
  return (
    <>
      <section className="bg-[#F5EFE6] border-b border-[#E2D3BE]">
        <div className="mx-auto max-w-6xl px-5 py-12 sm:py-16">
          <Breadcrumbs items={[{ name: 'FAQ', path: '/faq/' }]} />
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-[#2B1B12] tracking-tight mt-6">
            Tanya Jawab
          </h1>
          <p className="mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-[#6E6259]">
            Pertanyaan yang paling sering kami terima — tentang status produk, lokasi, jam buka,
            dan cara memesan.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-5 py-14 sm:py-20">
        <div className="space-y-4">
          {FAQS.map((f, i) => (
            <details
              key={f.q}
              data-testid={`faq-item-${i}`}
              className="faq-item rounded-lg border border-[#E2D3BE] bg-white open:shadow-md transition-shadow"
            >
              <summary className="flex items-center justify-between gap-4 p-5 sm:p-6 font-semibold text-[#1A110B] hover:text-[#C84B27] transition-colors">
                <span>{f.q}</span>
                <span aria-hidden="true" className="faq-caret shrink-0 font-display text-2xl text-[#D9822B] leading-none">
                  +
                </span>
              </summary>
              <p className="px-5 sm:px-6 pb-6 text-sm sm:text-base leading-relaxed text-[#6E6259] border-t border-dashed border-[#E2D3BE] pt-4">
                {f.a}
              </p>
            </details>
          ))}
        </div>

        <div className="mt-12 rounded-lg bg-[#1F140E] grain relative text-[#FDFBF7] p-8 flex flex-col sm:flex-row sm:items-center gap-6 justify-between">
          <div className="relative z-10">
            <h2 className="font-display text-2xl font-bold tracking-tight">Masih ada pertanyaan?</h2>
            <p className="mt-2 text-sm text-[#CBBBA6] leading-relaxed">
              Sapa kami di Instagram — kami senang membantu.
            </p>
          </div>
          <a
            data-testid="faq-cta-instagram"
            href={SITE.instagram.solo}
            target="_blank"
            rel="noopener noreferrer"
            className="relative z-10 shrink-0 inline-flex items-center bg-[#C84B27] text-[#FDFBF7] font-semibold px-6 py-3 rounded-md hover:bg-[#a93d1f] transition-colors active:scale-95"
          >
            Instagram Kami
          </a>
        </div>

        <p className="mt-8 text-sm text-[#6E6259]">
          Kembali ke{' '}
          <Link to="/" data-testid="faq-link-home" className="text-[#C84B27] font-semibold underline underline-offset-4 hover:text-[#a93d1f] transition-colors">
            Beranda
          </Link>
        </p>
      </section>
    </>
  );
}
